export type BlogCategory = 'ARTICLE' | 'POEM' | 'STORY' | 'OTHER';

export const BLOG_CATEGORIES: { value: BlogCategory; label: string }[] = [
    {value: 'ARTICLE', label: 'Article'},
    {value: 'POEM', label: 'Poem'},
    {value: 'STORY', label: 'Story'},
    {value: 'OTHER', label: 'Other'},
];

export interface Blog {
    blogId: string;
    status: 'PUBLISHED' | 'HIDDEN';
    title: string;
    category: BlogCategory;
    contentHtml?: string;      // only on the detail call
    excerpt: string;
    coverImageUri?: string;
    authorId: string;
    authorName: string;
    authorPhotoUri?: string;
    authorChapterId?: string;
    likeCount: number;
    commentCount: number;
    likedByMe: boolean;
    canEdit: boolean;
    canModerate: boolean;
    hiddenReason?: string;
    createdAtEpoch: number;
    createdDate: string;
    updatedDate?: string;
}

export interface BlogPage {
    items: Blog[];
    nextCursor: string | null;
}

export interface BlogComment {
    commentId: string;
    blogId: string;
    userId: string;
    userName: string;
    userPhotoUri?: string;
    text: string;
    createdAtEpoch: number;
    createdDate: string;
    canDelete: boolean;
}

export interface BlogDraft {
    title: string;
    category: BlogCategory;
    contentHtml: string;
}
